import DashboardLayout from '@/components/Dashboard/Layout/DashboardLayout.vue'

import MessengerPage from '@/pages/Messenger/Messenger.vue'
import {RouteConfig} from 'vue-router'

// @ts-ignore
import messages from '@/lang/index'

const sched: RouteConfig = {
  path: '/messeger',
  name: 'messeger',
  meta: {
    pageName: messages.messeger.messages
  },
  component: DashboardLayout,
  redirect: '/messeger/hist',
  children: [
    {
      path: 'hist',
      name: 'messegerPage',
      meta: {
        pageName: messages.messeger.history,
        hideBreadcrumbs: true,
        noFooter: true
      },
      component: MessengerPage
    }
  ]
}

export default sched